module.exports = __webpack_public_path__ + "img/image02.53cbf2b6.jpg";